import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=40fc2d5d&scoped=true"
import script from "./EmailDialog.vue?vue&type=script&lang=js"
export * from "./EmailDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailDialog.vue?vue&type=style&index=0&id=40fc2d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc2d5d",
  null
  
)

export default component.exports